import React, { useId } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

export function SoftUnlinkLicenseModal({ clientId, onConfirm, onClose }) {
  const titleId = useId();

  if (!clientId) {
    return null;
  }

  return (
    <SideDrawer
      open
      onClose={onClose}
      title="Отвязать лицензию"
      titleId={titleId}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={onClose} title="Закрыть" />}
      footer={
        <>
          <BtnPrimaryv4 text="Отвязать лицензию" onClick={onConfirm} />
          <BtnOutlineV4 text="Отмена" onClick={onClose} />
        </>
      }
    >
      <div className="site-modal-body">
        <p className="soft-unlink-license-modal__text">
          Вы уверены, что хотите отвязать лицензию от клиента{" "}
          <span className="company-card-v4-mono">{clientId}</span>?
        </p>
      </div>
    </SideDrawer>
  );
}
